import React from 'react';
import styled from 'styled-components';
import * as AppActions from '../../AppActions';
import BaseSection from '../../Components/BaseSection';
import Navbar from '../../Components/Navbar/custom';
import TextSection from '../../Components/TextSection';
import {useOutlet} from 'reconnect.js';
import nft from '../../Utils/Nft';
import {useOutletSetter} from 'reconnect.js';
import moment from 'moment';
import MintSection from './MintSection';
import InfoSection from './InfoSection';
import Constants from '../../../data.json';

const IS_STOP = false;

function isAllowMintFunc(time = new Date(), MINT_INFO, force = false) {
  if (force) {
    return true;
  }

  const {start, end} = MINT_INFO;
  const startTime = moment.utc(start);
  const endTime = moment.utc(end);
  const currentTime = moment.utc(time);

  return currentTime.isBetween(startTime, endTime, null, '[]');
}

const _MINT_INFO = {
  stg: {
    phase: 0, // whitelist: 0, public: 1
    start: '2023-04-26T02:37:00Z',
    end: '2023-10-26T02:47:00Z',
  },
  prod: {
    phase: 0, // whitelist: 0, public: 1
    start: '2023-06-16T12:00:00Z',
    end: '2023-08-17T12:00:00Z',
  },
};

function Landing(props) {
  useOutlet('update-counter');
  const setUpdateCnt = useOutletSetter('update-counter');
  const [dimension] = useOutlet('dimension');
  const [comingSoonCounter, setComingSoonCounter] = React.useState(0);

  const timer = React.useRef(null); // we can save timer in useRef and pass it to child

  const [MINT_INFO, setMINT_INFO] = React.useState(_MINT_INFO[Constants.stage]);

  if (IS_STOP) {
    return <div>offline</div>;
  }

  /*
  React.useEffect(() => {
    if (window.location.search.indexOf('phase=0') >= 0) {
      setMINT_INFO({
        phase: 0, // whitelist: 0, public: 1
        start: '2023-03-01T00:00:00Z',
        end: '2023-04-20T03:50:59Z',
      });
    } else {
      setMINT_INFO({
        phase: 1, // whitelist: 0, public: 1
        start: '2023-03-01T00:00:00Z',
        end: '2023-04-20T03:50:59Z',
      });
    }
  }, []);
  */

  React.useEffect(() => {
    // useRef value stored in .current property
    timer.current = setInterval(() => {
      if (comingSoonCounter > 0) {
        setComingSoonCounter(comingSoonCounter - 1);
      }
    }, 1000);

    // clear on component unmount
    return () => {
      clearInterval(timer.current);
    };
  }, [comingSoonCounter]);

  const onConnectWalletClick = async () => {
    if (
      isAllowMintFunc(
        new Date(),
        MINT_INFO,
        window.location.search.indexOf('mint=yyy') >= 0,
      )
    ) {
      try {
        AppActions.setLoading(true);
        await nft.connect();
      } catch (err) {
        console.log(err);
      }
      AppActions.setLoading(false);
      setUpdateCnt((cnt) => cnt + 1);
    } else {
      setComingSoonCounter(3);
    }
  };

  return (
    <Wrapper
      style={{
        backgroundColor: 'white',
      }}>
      <Navbar />

      {comingSoonCounter > 0 && (
        <div
          style={{
            position: 'fixed',
            top: 10,
            right: 20,
            borderRadius: 10,
            width: 120,
            backgroundColor: '#FDD36A',
            verticalAlign: 'middle',
            textAlign: 'center',
            color: 'white',
            padding: '5px 10px 5px 10px',
          }}>
          Coming Soon !
        </div>
      )}

      <div
        style={{
          backgroundImage: 'url("/images/foxfairy/banner.png")',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          height: 450,
          //backgroundPosition: 'center top',
          //backgroundSize: '100% auto',
          //height: 'calc(100vw * 480 / 1920 )',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <p
          style={{
            color: 'white',
            fontWeight: 'bold',
            fontSize: '3rem',
            textShadow: '2px 7px 5px rgba(0,0,0,0.3),  0px -4px 10px #69efff',
          }}>
          FoxFairyProject
        </p>
        {!nft.account && (
          <p
            onClick={onConnectWalletClick}
            //onMouseLeave={() => console.log('!!! off')}
            style={{
              cursor: 'pointer',
              backgroundColor: '#69efff',
              padding: '10px 20px 10px 20px',
              display: 'inline-block',
              color: 'white',
              borderRadius: 20,
              textShadow: 'black 0.1em 0.1em 0.2em',
              width: 150,
              textAlign: 'center',
              verticalAlign: 'middle',
              borderColor: 'white',
              borderWidth: 2,
              borderStyle: 'solid',
            }}>
            Connect Wallet
          </p>
        )}
        <p style={{fontSize: '1.2rem', color: 'white'}}>
          The fox fairy is my only faith
        </p>
        <div
          style={{
            maxWidth: 500,
            width: '60%',
            fontSize: '0.8rem',
            color: 'white',
          }}>
          Only the chosen believers can enter the sacred realm to witness the
          wonders of the divine. You shall be blessed to meet the 36 Apostles
          who bear the ancient legacy. You shall experience the grace of our
          Lord, and be welcomed into His kingdom. Receive the divine grace and
          you shall find true salvation. Let us bear witness together.
        </div>
      </div>

      <BGContainer>
        {nft.account && <MintSection mintInfo={MINT_INFO} />}
        <ScheduleSection style={{backgroundColor: 'transparent'}}>
          <div style={{width: 1, height: 80}} />
          <div className="content">
            <figure>
              <img src="/images/foxfairy/matrix.png" alt="" />
            </figure>

            <div style={{flex: '0 0 40px'}} />

            <div>
              <h1
                style={{
                  color: '#B7B78A',
                  fontSize: '2.5rem',
                  fontWeight: 'bold',
                }}>
                FoxFairy is the divine emissary.
              </h1>

              <p style={{color: 'black'}}>
                Humans' failure to abide by the covenant has led to disasters,
                and the divine will sign a new covenant with humankind in the
                promised land.
              </p>

              <p style={{color: 'black'}}>
                FoxFairy are the representatives of the divine and will assist
                the divine in signing the covenant with mankind.
              </p>

              <p>Every believer will be blessed by the FoxFairy.</p>

              <p style={{color: 'black'}}>
                FFP is the embodiment of 6666 FoxFairy, who can enter an
                exclusive realm to help the FoxFairy rebuild faith and assist
                the divine in signing the covenant with mankind.
              </p>

              <p style={{color: 'black'}}>
                Remember that the 6666 FFPs are but a part of our faith. We must
                entrench these principles in our hearts in order to find true
                solace and grace from the Almighty, to live out our faith.
              </p>
            </div>
          </div>
          <div style={{width: 1, height: 80}} />
        </ScheduleSection>

        <div
          style={{
            marginTop: -20,
            backgroundColor: 'transparent',
          }}>
          <div
            style={{
              width: '100%',
              maxWidth: 1024,

              marginLeft: 'auto',
              marginRight: 'auto',

              display: 'flex',
              flexDirection: dimension.rwd === 'desktop' ? 'row' : 'column',
              //flexWrap: 'wrap-reverse',
              justifyContent: 'center',
              alignItems: 'center',

              padding: 20,
            }}>
            {dimension.rwd !== 'desktop' && (
              <div
                style={{
                  width: 372,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}>
                <img
                  src="/images/foxfairy/promote.jpg"
                  alt=""
                  width="342"
                  style={{borderRadius: 20}}
                />
              </div>
            )}
            <div
              style={{
                color: 'white',
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
              }}>
              <div
                style={{
                  display: 'display',
                  flexDirection: 'column',
                  textAlign: dimension.rwd === 'desktop' ? 'start' : 'center',
                }}>
                <h1
                  style={{
                    color: '#B7B78A',
                    fontSize: '2.5rem',
                    fontWeight: 'bold',
                  }}>
                  Decentralized Faith
                </h1>

                <p style={{color: 'black'}}>
                  We are devoted to creating a decentralized faith with Fox
                  Fairy as its belief, comprising of doctrines, local chapters,
                  ordinances, orders of knights, apostles, worldviews, moral
                  outlooks, and funds.
                </p>
              </div>
            </div>

            <div style={{flex: '0 0 40px'}} />

            {dimension.rwd === 'desktop' && (
              <div
                style={{
                  width: 372,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}>
                <img
                  src="/images/foxfairy/promote.jpg"
                  alt=""
                  width="342"
                  style={{borderRadius: 20}}
                />
              </div>
            )}
          </div>
        </div>

        <div
          style={{
            width: '100%',
            backgroundColor: 'transparent',

            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 20,
          }}>
          <div
            style={{
              width: '100%',
              maxWidth: 1024,
              minHeight: 400,
              display: 'flex',
              flexWrap: 'wrap',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}>
            {[
              ['1.jpg', 'Ying No.1', 'Founder'],
              ['2.png', 'Justin No.2', 'Founder'],
              ['3.png', 'Bill No.3', 'Co-Founder'],
              ['4.png', 'Chevy No.4', 'Church Leaders'],
              ['5.png', 'Doble No.5', 'Conceptual artist'],
              ['6.png', 'Tiger No.6', 'VC'],
              ['7.png', 'Jeff No.7', 'Seed Investor'],
              ['8.png', 'Apolo No.8', 'Smart Contract Audit'],
            ].map((item) => {
              return (
                <div
                  key={item[0]}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: 2,
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    width: '25%',
                  }}>
                  <img
                    src={'/images/foxfairy/' + item[0]}
                    style={{width: '80%', borderRadius: '50%'}}
                  />
                  <div style={{fontSize: '1rem'}}>{item[1]}</div>
                  <div style={{textAlign: 'center', height: 20}}>{item[2]}</div>
                </div>
              );
            })}
          </div>
        </div>

        <InfoSection />

        <TextSection style={{backgroundColor: 'transparent'}}>
          <div className="content">
            <div style={{textAlign: 'center'}}>
              <h1
                style={{
                  color: '#A84448',
                  fontSize: '2.5rem',
                  fontWeight: 'bold',
                }}>
                Frequently Asked Questions
              </h1>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}>
                {[
                  [
                    'Is there a Discord?',
                    'Yes, but the FFP channels are NFT-gated (you must hold a FFP to enter) inside the FFP Discord.',
                  ],
                  [
                    'Is there a guaranteed mint allowlist?',
                    'Be ever watchful of the official updates that are currently in progress. Let us be vigilant in our faith and keep our spirits strong. May the divine grace be upon us all.',
                  ],
                  [
                    'What if some winners on the guaranteed mint allowlist do not mint?',
                    'We shall select more winners at random from the draw and bestow this reward upon them.',
                  ],
                  [
                    'What are the maximum mints per wallet?',
                    'Three mint per wallet is allowed per allowlist winner.',
                  ],
                  [
                    'What time can guaranteed mint allowlist winners mint?',
                    'I hereby proclaim that all believers should follow the official Twitter account for religious updates and guidance.',
                  ],
                  [
                    'What are the funds being used for?',
                    'All proceeds and fundraising efforts will be directly devoted to the propagation of our faith.',
                  ],
                  [
                    'Is there a future roadmap?',
                    'The Almighty shall lead us on the path He has chosen for us, for He is a God of great deeds and few words. We must remain devoted in our faith and spread the blessings of God to many.',
                  ],
                  [
                    'What are secondary royalties and how will they be used?',
                    'FFP will receive 10% of all secondary sales. These proceeds will be used to continue hiring more clergy, fund operations and create more value for our faith.',
                  ],
                ].map((item) => (
                  <FAQItem
                    key={item[0] + item[1]}
                    title={item[0]}
                    content={item[1]}
                  />
                ))}
              </div>
            </div>
          </div>
        </TextSection>

        <div
          style={{
            textAlign: 'center',
            width: '100%',
            paddingTop: 50,
            paddingBottom: 50,
          }}>
          <h1
            style={{
              //backgroundColor: '#240848',
              fontSize: '2rem',
              color: '#A0C3D2',
              textAlign: 'center',
              margin: '0 auto',

              width: '80%',
              maxWidth: 1000,
            }}>
            FoxFairyProject is composed of religious, innovators, clergy,
            creators, developers, entrepreneurs, and artists.
          </h1>
        </div>
      </BGContainer>
    </Wrapper>
  );
}

const FAQItem = ({title, content}) => {
  const [isOpen, setOpen] = React.useState(false);

  return (
    <div
      onClick={() => setOpen(!isOpen)}
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '60%',
        cursor: 'pointer',

        minWidth: 350,
        borderBottomColor: '#ECECEC',
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
        padding: '15px 0px 15px 0px',
      }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        <div
          style={{
            fontSize: '1.2rem',
            flex: 1.2,
            textAlign: 'left',
            color: '#E7B10A',
          }}>
          {title}
        </div>
        <div style={{fontSize: '1.2rem', flex: 0.1, color: '#FEC868'}}>
          {isOpen ? '▲' : '▼'}
        </div>
      </div>
      {isOpen && (
        <p style={{textAlign: 'left', marginTop: 5, color: '#3E54AC'}}>
          {content}
        </p>
      )}
    </div>
  );
};

const Wrapper = styled.div`
  & ul {
    color: white;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  @font-face {
    font-family: Garamond;
    src: url('/fonts/AGaramondPro-Regular.otf') format('opentype');
  }

  font-family: Garamond;
`;

const BGContainer = styled.div`
  background-image: url('/images/foxfairy/f-bg.png');

  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const HeroSection = styled(BaseSection)`
  & > .content {
    & > div {
      flex: 1 1 300px;
      & h2 {
        font-size: 4rem;
        line-height: 4rem;
        color: white;
      }
    }

    & > figure {
      flex: 1 0 300px;
      & img {
        width: 100%;
        object-fit: contain;
        overflow: hidden;
        border-radius: 20px;
      }
    }
  }
`;

const ScheduleSection = styled(BaseSection)`
  & > .content {
    & > div {
      flex: 1 1 500px;
      & h2 {
        font-size: 2rem;
        line-height: 2rem;
        color: white;
      }

      & h3 {
        font-size: 1.6rem;
        line-height: 1.6rem;
        color: yellow;
      }

      & p {
        font-size: 1rem;
        line-height: 1.2rem;
        color: white;
      }
    }

    & > figure {
      flex: 1 0 300px;
      & img {
        width: 100%;
        object-fit: contain;
        overflow: hidden;
        border-radius: 20px;
      }
    }
  }
`;

const WaveSection = styled(ScheduleSection)`
  & > .content {
    & > div {
      & h2 {
        color: yellow;
      }

      & h3 {
        color: white;
      }
    }
  }
`;

export default Landing;
